// get subscription user
export const GET_STATS_DETAILS_SUCCESS = "GET_STATS_DETAILS_SUCCESS";
export const GET_STATS_DETAILS__FAILED = "GET_STATS_DETAILS__FAILED";
export const IS_LOADING_GET_STATS_DETAILS = "IS_LOADING_GET_STATS_DETAILS";
